import * as sterlingparker from './CompetitionsMenu.styles.sterlingparker';
import * as volcanobet from './CompetitionsMenu.styles.volcanobet';
import * as betprofessor from './CompetitionsMenu.styles.betprofessor';
import * as puntgenie from './CompetitionsMenu.styles.puntgenie';
import * as junglebet from './CompetitionsMenu.styles.junglebet';
import * as fiestabet from './CompetitionsMenu.styles.fiestabet';
import * as puntcity from './CompetitionsMenu.styles.puntcity';
import * as betgalaxy from './CompetitionsMenu.styles.betgalaxy';
import * as betroyale from './CompetitionsMenu.styles.betroyale';
import * as juicybet from './CompetitionsMenu.styles.juicybet';
import * as goldenrush from './CompetitionsMenu.styles.goldenrush';
import * as vikingbet from './CompetitionsMenu.styles.vikingbet';
import * as questbet from './CompetitionsMenu.styles.questbet';
import * as wellbet from './CompetitionsMenu.styles.wellbet';
import * as sugarcastle from './CompetitionsMenu.styles.sugarcastle';
import * as oldgill from './CompetitionsMenu.styles.oldgill';
import * as buffalobet from './CompetitionsMenu.styles.buffalobet';
import * as titanbet from './CompetitionsMenu.styles.titanbet';
import * as gigabet from './CompetitionsMenu.styles.gigabet';
import * as slambet from './CompetitionsMenu.styles.slambet';
import * as betstride from './CompetitionsMenu.styles.betstride';
import * as templebet from './CompetitionsMenu.styles.templebet';
import * as goldenbet888 from './CompetitionsMenu.styles.goldenbet888';
import * as hyperbet from './CompetitionsMenu.styles.hyperbet';
import * as bet777 from './CompetitionsMenu.styles.bet777';
import * as chromabet from './CompetitionsMenu.styles.chromabet';
import * as bet575 from './CompetitionsMenu.styles.bet575';
import * as epicodds from './CompetitionsMenu.styles.epicodds';
import * as pyramidbet from './CompetitionsMenu.styles.pyramidbet';
import * as magnumbet from './CompetitionsMenu.styles.magnumbet';

import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  volcanobet,
  betprofessor,
  puntgenie,
  junglebet,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
